'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React, { useState, createContext } from 'react'
import moment from 'moment'

// lib
import { DEFAULT_HEADER_HEIGHT } from './symptom-log-history-header'

/* -----------------------------------------------------------------------------
 * SymptomLogHistoryContext
 * -------------------------------------------------------------------------- */

export type HeaderState = {
  date: moment.Moment
  logCount: number
}

const SymptomLogHistoryContext = createContext<{
  headerState: HeaderState
  setHeaderState: React.Dispatch<React.SetStateAction<HeaderState>>
  headerHeight?: number
}>({ headerState: undefined, setHeaderState: undefined })

type SymptomLogHistoryContextProviderProps = {
  children: React.ReactNode
  headerHeight: number
}

export const SymptomLogHistoryContextProvider = ({
  children,
  headerHeight = DEFAULT_HEADER_HEIGHT
}: SymptomLogHistoryContextProviderProps) => {
  const [headerState, setHeaderState] = useState<HeaderState>()

  return (
    <SymptomLogHistoryContext.Provider
      value={{ headerState, setHeaderState, headerHeight }}
    >
      {children}
    </SymptomLogHistoryContext.Provider>
  )
}

export default SymptomLogHistoryContext
